import {JobEventApiDto, JobSurveyFilesAttachedEventDataApiDto} from "../../../api/model/rest";
import AuthenticatedEntity from "../../user/AuthenticatedEntity";
import Attachment from "../../attachment/Attachment";
import {Icon} from "../../../hiberUiKit/src/atoms/Icon/Icon";
import {IconColor} from "../../../hiberUiKit/src/molecules/StreamItem/StreamItemIcon";
import moment = require("moment");
import JobEvent, {JobEventTypeEnum} from "./JobEvent";
import {option, Option} from "ts-option";

export default class JobSurveyFilesAttachedEvent extends JobEvent {

	/**
	 * @param {string} id identifier of event.
	 * @param {string} jobId job id.
	 * @param {JobEventTypeEnum} type type of the event.
	 * @param {AuthenticatedEntity} entity entity which creates the event.
	 * @param {moment.Moment} creationDate creation date of event.
	 * @param {string} referenceNumber job reference number.
	 * @param data job survey file
	 */
	constructor(public readonly id: string,
		public readonly jobId: string,
		public readonly type: JobEventTypeEnum,
		public readonly entity: AuthenticatedEntity,
		public readonly creationDate: moment.Moment,
		public readonly referenceNumber: string,
		public readonly data: JobSurveyFilesAttachedEventData) {
		super(id, jobId, type, entity, creationDate, referenceNumber);
	}

	public static fromJson(json: JobEventApiDto): JobSurveyFilesAttachedEvent {
		const data = JobSurveyFilesAttachedEventData.fromJson(json.data as JobSurveyFilesAttachedEventDataApiDto);
		const entity = AuthenticatedEntity.fromJson(json.entity);
		return new JobSurveyFilesAttachedEvent(json.id,
			json.jobId,
			JobEventTypeEnum.SurveyFilesAttached,
			entity,
			moment(json.createdAt),
			json.referenceNumber,
			data);
	}

	getIcon() {
		return Icon.File;
	}

	getIconColor(): IconColor {
		return IconColor.Burgundy;
	}

	getAttachments(): Attachment[] {
		return this.data.attachments;
	}

	getActivityType() {
		return "SURVEY"
	}

	getActivityMessage(): string {
		return "Files added";
	}
}

export class JobSurveyFilesAttachedEventData {
	constructor(public readonly jobSurveyId: string,
		public readonly attachments: Attachment[],
		public readonly surveyDescription: Option<string>) {}

	public static fromJson(json: JobSurveyFilesAttachedEventDataApiDto): JobSurveyFilesAttachedEventData {
		return new JobSurveyFilesAttachedEventData(json.jobSurveyId, json.attachments.map(Attachment.fromJson),
			option(json.surveyDescription));
	}
}
